module.exports = __webpack_public_path__ + "static/media/event-services-img44.bda54683.jpg";